<div class="wrapper mb-2">
    <div class="row">
        <div class="col-md-5 col-sm-12 text-left">
            <img src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Nova Recarga</span>
        </div>
        <!--navegação-->
        <div class="col-md-7 col-sm-12 p-0">
            <div class="row container-fluid menu-navegacao-borda m-0 bg-white">
                <div class="menu-navegacao-espacamento col d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">PRODUTOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">FAVORECIDOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">CRÉDITO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">CONFIRMAÇÃO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">PAGAMENTO</span>
                </div>
            </div>
        </div>
        <div class="component-box container-fluid">
            <form class="col-12" [formGroup]="purchaseForm" #colaboradorForm="ngForm"
                (ngSubmit)="onSubmit(purchaseForm.value)">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 text-left mt-5 mb-1">
                            <p class="component-title">Criar Recarga</p>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 text-left mt-1 mb-4">
                            <div class="btn-group mr-4 mb-2" role="group">
                                <button (click)="purchaseOnline = true;"
                                    [ngClass]="purchaseOnline ? 'btm custom-button-pedido selecionado' : 'btm custom-button-pedido' ">
                                    Online
                                </button>
                            </div>
                           <div class="btn-group mr-4 mb-2" role="group">
                                <button (click)="purchaseOnline = false;"
                                    [ngClass]="!purchaseOnline ? 'btm custom-button-pedido selecionado' : 'btm custom-button-pedido' ">
                                    por Arquivo
                                </button>
                            </div>
                        </div>

                        <div *ngIf="purchaseOnline" class="col-lg-12 col-md-12 col-sm-12 text-left form-title mt-5 mb-1">
                            <p class="component-title">Tipo de recarga</p>
                        </div>
                        <div *ngIf="purchaseOnline" class="col-lg-12 col-md-12 col-sm-12 text-left form-title mt-1 mb-4">
                            <div class="btn-group mr-4 mb-2" role="group">
                                <button (click)="newPurchase = true; copyPurchase = false; continuePurchase = false"
                                    [ngClass]="newPurchase ? 'btm custom-button-pedido selecionado' : 'btm custom-button-pedido' ">
                                    Nova recarga
                                </button>
                            </div>
                            <!--<div class="btn-group mr-4 mb-2" role="group">
                                <button
                                    (click)="copyPurchase = true; newPurchase = false; continuePurchase = false; carregarCopiarPurchase()"
                                    [ngClass]="copyPurchase ? 'btm custom-button-pedido selecionado' : 'btm custom-button-pedido'">
                                    Copiar recarga anterior
                                </button>
                            </div>-->
                            <!--<div class="btn-group mr-4 mb-2" role="group">
                                <button
                                    (click)="continuePurchase = true; newPurchase = false; copyPurchase = false; carregarContinuarPurchase()"
                                    [ngClass]="continuePurchase ? 'btm custom-button-pedido selecionado' : 'btm custom-button-pedido'">
                                    Continuar recarga salva
                                </button>
                            </div>-->
                        </div>

                        <!--Novo Pedido-->
                        <div *ngIf="newPurchase" class="row px-3">
                            <div class="col-lg-4 col-md-4 col-sm-12 mt-4">
                                <p class="component-title">Nome da recarga</p>
                                <!--                        <input class="input-pedido w-100" type="search" placeholder="Dê um nome ao seu pedido"-->
                                <!--                               [(ngModel)]="identificacaoPedido" />-->
                                <input class="input-pedido w-100" type="search" placeholder="Dê um nome a sua recarga"
                                    formControlName="purchaseDescription" />
                                <div *ngIf="form.purchaseDescription.invalid && (form.purchaseDescription.dirty || form.purchaseDescription.touched)"
                                    class="text-danger">
                                    <div *ngIf="form.purchaseDescription.errors.minlength">
                                        Nome da recarga deve conter no mínimo 3 caracteres.
                                    </div>
                                    <div *ngIf="form.purchaseDescription.errors.maxlength">
                                        Nome da recarga deve conter no máximo 100 caracteres.
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12 col-sm-12 text-left form-title mt-5 mb-1">
                                <p class="component-title">Selecione o tipo de produto</p>
                                <!--<p class="form-subtitle color">Selecione o incentivo que estará nesta recarga</p>-->

                                <div class="header-escolha row mt-3">
                                    <div class="header-margin row">
                                        <div class="header-separar row">
                                            <ng-container *ngFor="let item of produtoCategoria" >
                                                <div>
                                                     <!-- *ngIf="purchaseOnline|| (!purchaseOnline && item.id != categoriaProduto.Flex)"> -->
                                                    <div class="header-item">
                                                        <input value="{{item.id}}" type="radio" name="tipo-beneficio"
                                                            id="{{item.id}}" (change)="changeCategory($event)" [checked]="item.id == 1 ? true : '' ">
                                                        <label for="{{item.id}}" class="form-check-label font-weight-normal header-item-descricao">{{item.categoryAssignorLabel}}</label>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>

                                <div class="row m-0">
                                    <div class="col-auto mt-2 px-2"
                                        *ngFor="let listContratos of contractAssignor let i = index">
                                        <!--                            <input [attr.id]="listContratos.productEligibility.product.produtoGuid" name="beneficios" class="rdButton mx-2"-->
                                        <!--                                   type="radio" />-->
                                        <div class="imgCard">
                                            <div (click)='selecionarProduto()'>
                                                <input [attr.id]="listContratos.productEligibility.product.produtoGuid"
                                                    name="productId" class="rdButton mx-2" type="radio"
                                                    [value]="listContratos.productEligibility.product.produtoId" formArrayName="purchaseItens"/>
                                                <label [attr.for]="listContratos.productEligibility.product.produtoGuid"
                                                    class="form-check-label"><span
                                                        class="color-label">{{listContratos.productEligibility.product.descricaoProduto}}</span>
                                                <div class="">
                                                    <app-svg-card [color]="listContratos.productEligibility.product.corProduto" [icon]="listContratos.productEligibility.product.iconeProduto" [name]="listContratos.productEligibility.product.descricaoProduto"></app-svg-card>
                                                </div>
                                                </label>
                                            </div>

                                            <div class="mt-1" *ngIf="listContratos.productEligibility.product.categoriaProduto == categoriaProduto.Flex">
                                                <!-- <input id="flexIndividual" [checked]="!purchaseOnline" [disabled]="!purchaseOnline" -->
                                                <input id="flexIndividual"
                                                    name="flexIndividual" class="rdButton mx-2" type="checkbox" (change)="purchase.flexIndividual = $event.target.checked"/>
                                                <label for="flexIndividual" class="form-check-label">
                                                    <span class="color-label">Flex Individual</span>
                                                </label>    

                                                <p class="m-0 mt-1" style="font-size: small;">
                                                    Caso você queira apenas carregar o valor diretamente no saldo FLEX do favorecido
                                                </p>
                                            </div>
                                        </div>
                                    <!--div (click)='selecionarProduto()'>
                                            <input [attr.id]="listContratos.productEligibility.product.produtoGuid"
                                                name="productId" class="rdButton mx-2" type="radio"
                                                [value]="listContratos.productEligibility.product.produtoId" formArrayName="purchaseItens"/>
                                            <label [attr.for]="listContratos.productEligibility.product.produtoGuid"
                                                class="form-check-label"><span
                                                    class="color-label">{{listContratos.productEligibility.product.descricao}}</span>
                                                <div class="col-12 px-0">
                                                    <div class="imgCard">
                                                        <app-svg-card [color]="listContratos.productEligibility.product.color" [icon]="listContratos.productEligibility.product.iconeProduto" [name]="listContratos.productEligibility.product.descricao"></app-svg-card>
                                                    </div>
                                                    <--<img [src]="'./assets/icons/produtos/icon-produtos/'+ listContratos.productEligibility.product.produtoGuid +'.svg'"
                                                        onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';"
                                                        class="imgCard"
                                                        alt="{{listContratos.productEligibility.product.descricao}}" />->
                                                </div>
                                            </label>
                                            <-- <section class="mt-1">  
                                                <mat-checkbox *ngIf="listContratos.productEligibility.product.produtoCategoria == categoriaProduto.Flex" color="primary" (change)="purchase.flexIndividual = $event.checked">Bloquear o cartão</mat-checkbox>
                                            </section> ->
                                            <section class="mt-1" *ngIf="listContratos.productEligibility.product.produtoCategoria == categoriaProduto.Flex">   
                                                <input id="flexIndividual" [checked]="!purchaseOnline" [disabled]="!purchaseOnline"
                                                    name="flexIndividual" class="rdButton mx-2" type="checkbox" (change)="purchase.flexIndividual = $event.target.checked"/>
                                                <label for="flexIndividual" class="form-check-label">
                                                    <span class="color-label">
                                                        <div class="col-12 px-0">
                                                        Flex Individual
                                                        <br>Caso você queira apenas carregar o valor diretamente no saldo FLEX do favorecido
                                                        </div>
                                                    </span>
                                                </label>
                                            </section>
                                        </div-->
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="form.purchaseItens.invalid && (form.purchaseItens.dirty || form.purchaseItens.touched)"
                                class="alert alert-danger" role="alert">
                                <div *ngIf="form.purchaseItens.errors.required">
                                    Escolha algum incentivo.
                                </div>
                            </div>

                            <div class="col-12 text-right button-container mt-5 mb-3">
                                <button type="submit" class="custom-button-full">
                                    Continuar
                                </button>
                            </div>
                        </div>

                        <!--Copiar Pedido-->
                        <div *ngIf="copyPurchase" class="row px-3">
                            <div class="col-lg-12 col-md-12 col-sm-12 text-left form-title mt-3 mb-1">
                                <p class="form-title">SELECIONE A RECARGA A COPIAR</p>
                                <p class="form-subtitle color">Selecione uma de suas recargas anteriores que deseja copiar
                                    nesta recarga</p>
                            </div>

                            <div *ngFor="let item of purchaseCopyList" class="my-2 py-2 col-lg-4 col-md-6 col-sm-12">
                                <div class="row container pedido-card py-4" (click)="copiar(item)">
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">N° da recarga:</div>
                                            <div class="col-12 pedido-card-title content">{{item.purchaseId}}</div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">Data da recarga:</div>
                                            <div class="col-12 pedido-card-title content">
                                                {{item.purchaseDate | date: 'dd/MM/yyyy'}}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">Nome:</div>
                                            <div class="col-12 pedido-card-name">{{item.identifier}}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">
                                                <hr style="background: #313840;">
                                            </div>
                                        </div>
                                    </div>
                                    <!--<div class="col-6">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">Incentivos:</div>
                                            <div class="col-12 pedido-card-info">{{item.productDescription}}</div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">Favorecidos:</div>
                                            <div *ngIf="purchaseCopyList.purchaseItens === null" class="col-12 pedido-card-info">Sem favorecidos</div>
                                            <div *ngIf="purchaseCopyList.purchaseItens != null" class="col-12 pedido-card-info">{{item.purchaseItens.length}}</div>
                                        </div>
                                    </div>-->
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">Valor total da recarga:</div>
                                            <div class="col-12 pedido-card-info">{{item.purchaseValue | currency:'BRL':true}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">Data do crédito:</div>
                                            <div class="col-12 pedido-card-info">
                                                {{item.purchaseDate | date: 'dd/MM/yyyy'}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--Continuar Pedido-->
                        <!--<div *ngIf="continuePurchase" class="row px-3">
                            <div class="col-lg-12 col-md-12 col-sm-12 text-left form-title mt-3 mb-1">
                                <p class="form-title">SELECIONE A RECARGA SALVA</p>
                                <p class="form-subtitle color">Selecione uma de suas recargas salvas, para continuar de
                                    onde parou</p>
                            </div>

                            <div *ngFor="let item of purchaseContinueList" class="my-2 py-2 col-lg-4 col-md-6 col-sm-12">
                                <div class="row container pedido-card py-4" (click)="continuar(item)">
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">N° da recarga:</div>
                                            <div class="col-12 pedido-card-title content">{{item.purchaseId}}</div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">Data do salvamento:</div>
                                            <div class="col-12 pedido-card-title content">
                                                {{item.purchaseDate | date: 'dd/MM/yyyy'}}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">Nome:</div>
                                            <div class="col-12 pedido-card-name">
                                                {{item.identifier == "" ? "-" : item.identifier}}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">
                                                <hr style="background: #313840;">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">Incentivos:</div>
                                            <div class="col-12 pedido-card-info">
                                                {{item.productDescription == "" ? "-":item.productDescription}}</div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">Favorecidos:</div>
                                            <div *ngIf="item.purchasesItens != null" class="col-12 pedido-card-info">
                                                {{ item.purchasesItens.length <= 0 ? "-":item.purchasesItens.length}}</div>
                                            <div *ngIf="item.purchasesItens === null" class="col-12 pedido-card-info">
                                                {{ item.purchasesItens.length <= 0 ? "-":item.purchasesItens.length}}</div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">Valor total da recarga:</div>
                                            <div class="col-12 pedido-card-info">
                                                {{ item.purchaseValue == "" ? "-" : (item.purchaseValue | currency:'BRL':true)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-12 pedido-card-title">Data do crédito:</div>
                                            <div class="col-12 pedido-card-info">
                                                {{item.purchaseDate == null ? "-" :(item.purchaseDate | date: 'dd/MM/yyyy')}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>-->
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!--Modal Produto não contratado-->
<ng-template #noContrato let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Nenhum contrato aceito!</h5>
        </div>
    </div>
</ng-template>




<!--Modal copiar pedido-->
<ng-template #pedidoCopiarModal let-modal>
    <div class="container custom-filter">
        <div class="row mx-1">
            <div class="col-12 custom-filter-title my-5">Recargas anteriores</div>

            <div class="table-responsive custom-bg-white container-fluid">
                <table class="list-table table table-striped" *ngIf="purchaseCopyList.length > 0">
                    <thead class="list-table-head">
                        <th>Nº da recarga</th>
                        <th>Identificador da recarga</th>
                        <th>Data de alteração</th>
                        <th>Incentivo</th>
                        <th>Valor total</th>
                        <th>Situação</th>
                    </thead>
                    <tbody class="list-table-row">
                        <tr *ngFor="let item of purchaseCopyList | paginate: { itemsPerPage: 8, currentPage: 1 }"
                            class=" list-table-cell" class="clickable"
                            (click)="copiar(item);modal.dismiss('Close click')">
                            <td style="white-space: nowrap;">{{item.purchaseId}}</td>
                            <td style="white-space: nowrap;">{{item.identifier}}</td>
                            <td style="white-space: nowrap;">{{item.purchaseDate | date: 'dd/MM/yyyy HH:mm'}}</td>
                            <td style="white-space: nowrap;">{{item.productDescription}}</td>
                            <td style="white-space: nowrap;">{{item.purchaseValue | currency:'BRL':true}}</td>
                            <td style="white-space: nowrap;">{{item.purchaseStateDescription}}</td>
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="purchaseCopyList.length === 0">
                    <div class="mx-auto text-center bg-white">Não há recargas anteriores para copiar</div>
                </div>
            </div>

            <div class="col-12 text-center my-5">
                <button class="custom-filter-button" type="button" (click)="modal.dismiss('Close click')">
                    Fechar
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!--Modal de Aviso-->
<ng-template #modalAvisoColaboradores let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Favorecidos
            </h5>
            <p class="clean-modal-subtitle" style="font-size: 20px;">
                Não existe favorecido cadastrado para realizar um pedido de cartões.<br>
                Faça o cadastro!
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)="modal.dismiss('Close click');navigateToHome()">Fechar</button>
        <button class="custom-filter-button custom-filter-button-just" style="background-position: 90% 50%" type="button" type="button" (click)="modal.dismiss('Close click');navigateToCadastroColaborador();">Cadastrar Favorecido</button>
    </div>
</ng-template>
